module.exports = __webpack_public_path__ + "static/media/tap-professional.621e61e3.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/tap-professional.mp3
// module id = 1377
// module chunks = 1